import "../style/style.scss";
import 'bootstrap';
import $ from 'jquery';

import { Tooltip } from 'bootstrap';

window.jQuery = $;
window.$ = $;

// using jQuery
function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
const csrftoken = getCookie('csrftoken');

$(document).ready(function(){
    $("[data-bs-toggle='tooltip']").each(function() {
        new Tooltip($(this));
    });
});

import Lightbox from 'bs5-lightbox';

window.Lightbox = Lightbox;

import 'flowplayer';
